module.exports = __webpack_public_path__ + "img/jianyi.e9c59c64.svg";